import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import RankingSalesReportActions from "../../../../reducers/modules/report/ranking-sales/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "report/ranking-sales";

export default class RankingSalesMiddleware {
  static beforeShowExcel(params) {
    return (dispatch) => {
      dispatch(RankingSalesReportActions.process());
      RankingSalesMiddleware.showExcel(dispatch, params);
    };
  }

  static async showExcel(dispatch, params) {
    const token = await RankingSalesMiddleware.getToken();
    axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: process.env.REST_URL + "report/ranking-sales",
      method: "POST",
      params: params,
      responseType: "blob",
    })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          MySwal.fire({
            title: "Convert Excel",
            html:  "Download Successfully",
            icon: "success",
            showConfirmButton: true,
          });
       
          var urlCreator = window.URL || window.webkitURL;
          const blobUrl = urlCreator.createObjectURL(response.data);
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = blobUrl;
          link.setAttribute(
            "download",
            "Ranking Sales.xlsx"
          );
          document.body.appendChild(link);
          link.click();
          link.remove();

        }
        dispatch(RankingSalesReportActions.success());
      })
      .catch((error) => {
        RankingSalesMiddleware.alertHendler(dispatch,error
        );
      });
  }

  static reset() {
    return (dispatch) => {
      dispatch(RankingSalesReportActions.reset());
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static getHelper(params = null) {
    return (dispatch) => {
      RankingSalesMiddleware.showHelper(dispatch, params);
    };
  }

  static showHelper(dispatch, params) {
    
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${RankingSalesMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-ranking-sales",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RankingSalesReportActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        RankingSalesMiddleware.alertHendler(dispatch, error);
      });
  }

  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(RankingSalesReportActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(RankingSalesReportActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
